<template>
  <v-expansion-panel>
    <v-expansion-panel-header>
      {{ $t('settingsView.imprint') }}
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-list
        v-if="imprintContent !== undefined"
        disabled
        flat
        class="ma-0"
      >
        <v-list-item-group>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="text-wrap">
                Angaben gemäß § 5 TMG
              </v-list-item-title>
              <v-list-item-subtitle class="text-wrap">
                {{ imprintContent.general.name }}<br>
                {{ imprintContent.general.address }}<br>
                <div v-if="imprintContent.general.handelsregister !== undefined">
                  {{ imprintContent.general.handelsregister }}<br>
                </div>
                <div v-if="imprintContent.general.registergericht !== undefined">
                  {{ imprintContent.general.registergericht }}
                </div>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="text-wrap">
                {{ imprintContent.general.representation.heading }}
              </v-list-item-title>
              <v-list-item-subtitle class="text-wrap">
                {{ imprintContent.general.representation.content }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="text-wrap">
                Kontakt
              </v-list-item-title>
              <v-list-item-subtitle class="text-wrap">
                <div
                  v-for="(contactObject, i) in imprintContent.general.contact"
                  :key="i"
                >
                  {{ contactObject }}
                </div>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-for="(item, i) in imprintContent.content"
            :key="i+100"
          >
            <v-list-item-content>
              <v-list-item-title class="text-wrap">
                {{ item.title }}
              </v-list-item-title>
              <v-list-item-subtitle class="text-wrap">
                {{ item.subtitle }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<script>

export default {
  name: 'Imprint',
  components: {
  },
  props: {},
  data() {
    return {
      imprintContent: this.$imprint,
    };
  },
  mounted() {
  },
  methods: {
  },
};

</script>
<style scoped>
</style>
